export default __webpack_public_path__ + "static/media/helicopter-active.a929e1c8.svg";